import {
  permissionsUsersReadonly,
  permissionsCompaniesReadonly,
  permissionsLocationsReadonly,
  permissionsSettings,
} from "@/utils";

export const permissionsCompanyMenu = [
  ...permissionsUsersReadonly,
  ...permissionsCompaniesReadonly,
  ...permissionsLocationsReadonly,
  ...permissionsSettings,
];
